/**
 * @generated SignedSource<<42ada7368d33d2e53de14cbb11f615e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getDrawingSetSheetQuery$variables = {
  id: string;
};
export type getDrawingSetSheetQuery$data = {
  readonly drawingSetSheet: {
    readonly " $fragmentSpreads": FragmentRefs<"drawingSetSheetFragment">;
  } | null | undefined;
};
export type getDrawingSetSheetQuery = {
  response: getDrawingSetSheetQuery$data;
  variables: getDrawingSetSheetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getDrawingSetSheetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetSheet",
        "kind": "LinkedField",
        "name": "drawingSetSheet",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "drawingSetSheetFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getDrawingSetSheetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetSheet",
        "kind": "LinkedField",
        "name": "drawingSetSheet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "versionDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "drawingSetId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "number",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRemoved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "order",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revision",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e61f9995720b3825ecb7802e460df01",
    "id": null,
    "metadata": {},
    "name": "getDrawingSetSheetQuery",
    "operationKind": "query",
    "text": "query getDrawingSetSheetQuery(\n  $id: ID!\n) {\n  drawingSetSheet(id: $id) {\n    ...drawingSetSheetFragment\n    id\n  }\n}\n\nfragment drawingSetSheetFragment on DrawingSetSheet {\n  id\n  createdAt\n  updatedAt\n  createdById\n  versionDate\n  drawingSetId\n  number\n  name\n  isRemoved\n  order\n  revision\n}\n"
  }
};
})();

(node as any).hash = "e1c117cbcf89552cdc753edf788dd545";

export default node;
